<div class=" text-center relatorio-item">
  <h3 class="cabecalho-link-download">{{modelo.titulo}}</h3>
  <a mat-raised-button color="primary" [href]="modelo.endereco_relatorio">
    PDF
      <mat-icon >cloud_download</mat-icon>
  </a>
  <mat-divider></mat-divider>
</div>
